// Arabic-Indic (U+0660–U+0669, ٠-٩) and Eastern Arabic-Indic / Persian
// (U+06F0–U+06F9, ۰-۹) digits — the two sets an Arabic phone keyboard can
// produce. Any other script's digits are left as they are.
const ARABIC_INDIC_DIGITS = /[٠-٩۰-۹]/g;
const NON_ASCII_DIGIT = /[^0-9]/g;
function toAsciiDigit(digit) {
    const code = digit.charCodeAt(0);
    const zero = code >= 0x06f0 ? 0x06f0 : 0x0660;
    return String(code - zero);
}
/**
 * Folds Arabic-Indic and Eastern Arabic-Indic digits to ASCII `0-9` and
 * leaves every other character untouched. «٠١٠٠ ١٢٣» → «0100 123».
 *
 * The ONE digit folding for the platform: the backend's phone normaliser,
 * the restaurant's delivery-ref key and the restaurant app's phone box all
 * use it, so a number typed on either keyboard compares equal everywhere.
 * The database backfill of `restaurant_invoices.customer_phone_tail` mirrors
 * these exact two ranges in SQL (`translate()`), so a change here must be
 * made there too.
 */
export function foldArabicDigits(raw) {
    return raw.replace(ARABIC_INDIC_DIGITS, toAsciiDigit);
}
/**
 * The ASCII digits of `raw` after `foldArabicDigits`, everything else dropped.
 * «+20 (100) ١٢٣-4567» → «201001234567».
 */
export function asciiDigitsOnly(raw) {
    return foldArabicDigits(raw).replace(NON_ASCII_DIGIT, '');
}
//# sourceMappingURL=digits.js.map